const toPct = (base) => {
    return `${base * 100}%`;
};
// The layout is based on a 12-column grid
const cols = {
    one: 1 / 12,
    two: 2 / 12,
    three: 3 / 12,
    four: 4 / 12,
    five: 5 / 12,
    six: 6 / 12,
    seven: 7 / 12,
    eight: 8 / 12,
    nine: 9 / 12,
    ten: 10 / 12,
    eleven: 11 / 12,
    twelve: 12 / 12,
};
const sizes = [
    '0',
    ...Object.values(cols)
        .sort((a, b) => a - b)
        .map((col) => toPct(col)),
];
export default sizes;
//# sourceMappingURL=sizes.js.map